<template>
  <b-card header-tag="header" class="m-3" no-body>
    <template #header>
      <header-sagres titulo="De/Para Contas Caixa" breakpoint="xl" />
    </template>
    <b-card-body>
      <b-col lg="6" class="filtro-pesquisa  float-right">
        <b-form-group
          label-for="filter-input"
          label-align-sm="right"
          label-size="sm"
          class="mb-3"
        >
          <b-input-group size="sm">
            <b-form-input
              id="filter-input"
              v-model="filter"
              type="search"
              class="search-input"
              placeholder="Pesquisar"
            />
            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''">Limpar</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-table
        id="contasCaixaTable"
        :fields="fields"
        :items="items"
        :busy="tableBusy"
        :current-page="currentPage"
        :filter="filter"
        hover
        no-border-collapse
        sort-by=""
        :sort-desc="true"
        striped
        stacked="xl"
        show-empty
        per-page="10"
        @filtered="onFiltered"
      >
        <template #empty>
          <span>Não foram encontrados dados.</span>
        </template>
        <template #emptyfiltered>
          <span>Não foram encontrados dados.</span>
        </template>
        <template #table-busy>
          <div class="text-center text-dark">
            <b-spinner class="align-middle" />
            <strong class="loading-text">Carregando...</strong>
          </div>
        </template>
        <template v-slot:cell(actions)="row">
          <div
            class="actions-icons lgvert d-none d-md-flex justify-content-center"
          >
            <b-link class="text-dark" @click="openModal(row.item)">
              <font-awesome-icon icon="edit" />
              <div style="font-size: 12px">Editar</div>
            </b-link>
          </div>
        </template>
      </b-table>
      <b-pagination
        v-model="currentPage"
        :total-rows="totalRows"
        :per-page="10"
        aria-controls="contasCaixaTable"
      />
    </b-card-body>

    <ModalNovoNumero
      v-if="modalAberto"
      :conta="contaSelecionada"
      @close="closeModal"
    />
  </b-card>
</template>

<script lang="ts">
import HeaderSagres from "@/components/shared/HeaderSagres.vue";
import { store } from "@/store";
import { TableField } from "@/types/table-field";
import { UtilsTS } from "@/utilsts";
import { mixins } from "vue-class-component";
import { Component, Vue } from "vue-property-decorator";
import { fieldsContasCaixa } from "@/types/entregas/pcm/fields-conta-caixa";
import pcmService from "@/services/entregas/pcmService";
import { ContaCaixa } from "@/types/entregas/pcm/conta-caixa";
import ModalNovoNumero from "@/components/entregas/pcm/ModalNovoNumero.vue";

const CompProps = Vue.extend({
  name: "Consultar",
  components: {
    HeaderSagres,
    ModalNovoNumero,
  },
});

@Component
export default class DeParaContasCaixa extends mixins(UtilsTS, CompProps) {
  modalAberto = false;
  contaSelecionada: ContaCaixa | null = null;

  fields: TableField[] = fieldsContasCaixa;
  items: ContaCaixa[] = [];

  filter = "";
  currentPage = 1;
  pageSize = 10;
  totalRows = 0;
  tableBusy = false;

  async created() {
    try {
      store.blockScreen = true;
      await this.loadData();
    } catch (e) {
      console.error(e);
    } finally {
      store.blockScreen = false;
    }
  }

  async loadData(): Promise<any> {
    try {
      this.tableBusy = true;
      const response = await pcmService.listarContasCaixa();
      if (!response)
        return this.$toast.error("Erro ao obter a lista de contas");
      this.items = response;
      this.totalRows = response.length;
    } catch (e: any) {
      this.tratarError(e);
      this.items = [];
      this.totalRows = 0;
    } finally {
      this.tableBusy = false;
    }
  }

  openModal(conta: ContaCaixa) {
    if (conta) {
      this.contaSelecionada = conta;
      this.modalAberto = true;
    } else this.$toast.error(`Erro ao obter dados da conta`);
  }

  closeModal() {
    this.modalAberto = false;
    this.loadData();
  }

  onFiltered(filteredItems: any): any {
    this.totalRows = filteredItems.length;
    this.currentPage = 1;
  }
}
</script>